import ApplicationSummary from '@/components/ApplicationSummary';
import { useGetRefinanceAssessmentSummaryQuery } from '@/pages/mortgage/apis/refinanceAPI';
import { Typography } from 'antd';
import { useParams } from 'react-router-dom';
const RefinanceApplicationSummary = () => {
  const params = useParams();
  const { data, isLoading } = useGetRefinanceAssessmentSummaryQuery(
    {
      application_id: params.id as string,
    },
    {
      skip: !params.id,
    },
  );
  return (
    <div>
      <Typography.Title level={3}>
        Refinance Application Summary
      </Typography.Title>
      <ApplicationSummary data={data} isLoading={isLoading} />
    </div>
  );
};

export default RefinanceApplicationSummary;
